import type { ViewGroup } from "@omnabase/ui";
import { ALL_SETTINGS_SECTIONS, settingsSectionAllowed, settingsSectionsFor, type Capability } from "@omnabase/shared";
import { useSession } from "../shell/store";
import { capsOf } from "./access";
import { useWs } from "./nav";

/** Two groups: what is yours (on a phone without Profile and Notifications, which More holds), and what belongs to the workspace. Which workspace sections a person gets follows their capabilities
 *  (the shared `settingsSectionsFor`, 2026-10-05): Team with `team`, Billing with `billing`, Integrations with `projectSettings`. */
export const SECTIONS = ALL_SETTINGS_SECTIONS;
export const settingsGroups = (active: string, ws: (p: string) => string, caps: ReadonlySet<Capability>, owner: boolean): ViewGroup[] =>
  settingsSectionsFor(caps, { owner }).map((g) => ({ label: g.label, phoneHidden: g.phoneHidden, items: g.sections.map((x) => ({ id: x.id, label: x.label, icon: x.icon as ViewGroup["items"][number]["icon"], href: ws(`/settings/${x.id}`), active: x.id === active, phoneHidden: x.phoneHidden })) }));

/** the column for the signed-in person, with `active` selected */
export function useSettingsGroups(active: string): ViewGroup[] {
  const { workspace } = useSession(); const { ws } = useWs();
  return settingsGroups(active, ws, capsOf(workspace), workspace.me.role === "owner");
}
/** whether a section is the signed-in person's (a section opened by its address that is not theirs is a plain not-found) */
export function useSectionAllowed(): (id: string) => boolean {
  const { workspace } = useSession();
  const caps = capsOf(workspace);
  return (id) => settingsSectionAllowed(id, caps);
}
